import React, { useEffect, useRef, useState } from "react"
import { PageProps } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import * as styles from "./projects.module.scss"

import Layout from "../../components/Layout/Layout"
import SEO from "../../components/seo"
import ProjectsList from "../../components/Parts/ProjectsList/ProjectsList"
import SecondTitle from "../../components/UI/SecondTitle/SecondTitle"


const Projects: React.FC<PageProps> = ({ location }) => {
	const intl = useIntl()

	return (
		<Layout location={location}>
			<SEO
				language={intl.locale}
				description={intl.formatMessage({ id: "projects.seo.description" })}
				title={intl.formatMessage({ id: "projects.seo.title" })}
				pathname={location.pathname}
			/>
			<SecondTitle desktopImage="/images/pages-heading/projects.png" mobileImage="/images/pages-heading/m-projects.png" title={intl.formatMessage({ id: "projects.banner.title" })} position="right center" />
			<div className={styles.container}>
				<div className={styles.intro}>
					<p>
						{intl.formatMessage({ id: "projects.banner.paragraph-1" })}
					</p>
				</div>
				<ProjectsList />
			</div>
		</Layout>
	)
}

export default Projects;
